(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["upland-protein"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('upl-qty-card')) {
    class UplQtyCard extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section') || document;
        this.addEventListener('change', (event) => {
          const target = event.target;
          if (target instanceof HTMLInputElement && target.type === 'radio') this.setQuantity(target.value);
        });
        this.syncHandler = () => window.setTimeout(() => this.syncFromInput(), 0);
        this.section.addEventListener('change', this.syncHandler);
        this.section.addEventListener('click', this.syncHandler);
        this.syncFromInput();
      }
      disconnectedCallback() {
        if (!this.section) return;
        this.section.removeEventListener('change', this.syncHandler);
        this.section.removeEventListener('click', this.syncHandler);
      }
      getInput() {
        return this.section.querySelector('product-form-component input[name="quantity"], input[name="quantity"]');
      }
      setQuantity(value) {
        const selector = this.section.querySelector('product-form-component quantity-selector-component');
        const input = this.getInput();
        if (selector && typeof selector.setValue === 'function') {
          selector.setValue(String(value));
        } else if (input) {
          input.value = String(value);
        }
        if (input) {
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      syncFromInput() {
        const input = this.getInput();
        if (!input) return;
        const radios = this.querySelectorAll('input[type="radio"]');
        radios.forEach((radio) => {
          radio.checked = radio.value === String(parseInt(input.value, 10) || 1);
        });
      }
    }
    customElements.define('upl-qty-card', UplQtyCard);
  }
  } catch(e) { console.error(e); }
})();

})();
